export default "__VITE_ASSET__DhZ4iPw4__"